import React from 'react';
import { FieldVisibilityContext } from '../contexts/contexts';

export const useFieldVisibility = () => {
  const context = React.useContext(FieldVisibilityContext);
  if (context === undefined) {
    throw new Error('useFieldVisibility must be used within a FieldVisibilityProvider');
  }
  return context;
};
